import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
} from '@mui/material';
import {
  VerifiedUser,
  Assessment,
  Insights,
} from '@mui/icons-material';

const ValidationInsightsSection = () => {
  const features = [
    {
      icon: VerifiedUser,
      title: 'Dual Validation',
      description: 'Validate both employee performance and program success through structured session tracking and real-time data.',
      color: '#2196f3',
    },
    {
      icon: Assessment,
      title: 'Form-Driven Insights',
      description: 'Every session check-in transforms into actionable intelligence, giving you clear metrics on what works.',
      color: '#4caf50',
    },
    {
      icon: Insights,
      title: 'One Unified View',
      description: 'See the complete picture—program outcomes and employee effectiveness—all in a single, powerful dashboard.',
      color: '#ff9800',
    },
  ];

  return React.createElement(
    Box,
    {
      sx: {
        py: { xs: 6, md: 8 },
        backgroundColor: '#f8f9fa',
      },
    },
    React.createElement(
      Container,
      { maxWidth: 'lg' },
      // Header
      React.createElement(
        Box,
        { sx: { textAlign: 'center', mb: 6 } },
        React.createElement(
          Chip,
          {
            label: 'WHY CHOOSE US',
            sx: {
              mb: 2,
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              fontWeight: 600,
            },
          }
        ),
        React.createElement(
          Typography,
          {
            variant: 'h3',
            sx: {
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '1.75rem', md: '2.5rem' },
              color: '#1a1a1a',
            },
          },
          'Double the Validation, ',
          React.createElement(
            Box,
            { component: 'span', sx: { color: '#2196f3' } },
            'Triple the Insights'
          )
        ),
        React.createElement(
          Typography,
          {
            variant: 'body1',
            sx: {
              color: '#666',
              maxWidth: '650px',
              mx: 'auto',
              fontSize: '1.1rem',
              lineHeight: 1.7,
            },
          },
          'The only platform that validates employee performance while tracking program success—turning every session into data that drives better decisions.'
        )
      ),
      // Feature Cards
      React.createElement(
        Grid,
        { container: true, spacing: 3 },
        features.map((feature, index) =>
          React.createElement(
            Grid,
            { item: true, xs: 12, md: 4, key: index },
            React.createElement(
              Card,
              {
                elevation: 0,
                sx: {
                  height: '100%',
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                    borderColor: feature.color,
                  },
                },
              },
              React.createElement(
                CardContent,
                { sx: { p: 3 } },
                React.createElement(
                  Box,
                  { sx: { mb: 2 } },
                  React.createElement(feature.icon, {
                    sx: { fontSize: 48, color: feature.color },
                  })
                ),
                React.createElement(
                  Typography,
                  {
                    variant: 'h6',
                    sx: { fontWeight: 700, mb: 1.5, color: '#1a1a1a' },
                  },
                  feature.title
                ),
                React.createElement(
                  Typography,
                  {
                    variant: 'body2',
                    sx: { color: '#666', lineHeight: 1.7 },
                  },
                  feature.description
                )
              )
            )
          )
        )
      )
    )
  );
};

export default ValidationInsightsSection;